import React from 'react';
import { Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { PageSection } from 'src/components/selfService/layout/PageSection/PageSection';
import { useBalanceContext } from 'src/components/selfService/common/Balance/hooks/useBalanceContext';
import { PageSectionTitle } from 'src/components/selfService/layout/PageSectionTitle/PageSectionTitle';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { BalanceCreditProgressSectionFooter } from 'src/components/selfService/common/Balance/sections/BalanceCreditProgressSection/BalanceCreditProgressSectionFooter';
import { BalanceCreditProgressSectionBody } from 'src/components/selfService/common/Balance/sections/BalanceCreditProgressSection/BalanceCreditProgressSectionBody';

export function BalanceCreditProgressSection(): JSX.Element {
  const { isOnNetTerms } = useBalanceContext();
  const { corpData } = useAuth();

  if (!isOnNetTerms) {
    return null;
  }

  return (
    <Stack y="md" position="relative">
      <PageSection bg="globals.white">
        <Flex flexDirection="column" style={{ gap: '24px' }}>
          <PageSectionTitle
            title={`${corpData.name}’s line of credit`}
            subtitle="This overview shows your available credit and limit"
            y="none"
            subtitleY="xxx-sm"
            headingVariant="h3"
          />
          <BalanceCreditProgressSectionBody />
          <BalanceCreditProgressSectionFooter />
        </Flex>
      </PageSection>
    </Stack>
  );
}
